import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ForbiddenService } from '../services/forbidden.service';

export class AuthInterceptor implements HttpInterceptor {
  private readonly excludedUrls: string[];
  private readonly tariffsUrl = `${environment.apiUrl}/tariffs`;
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly forbiddenService = inject(ForbiddenService);

  constructor() {
    this.excludedUrls = [
      `${environment.baseUrl}/login`,
      `${environment.baseUrl}/register`
    ];
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isExcludedUrl = this.excludedUrls.some((u) => req.url.includes(u));
    const isPublicTariffGetRequest =
      req.method === 'GET' && req.url.startsWith(this.tariffsUrl);

    if (isExcludedUrl || isPublicTariffGetRequest) {
      return next.handle(req);
    }

    const user = this.authService.user$.getValue();
    const authToken = `${user.tokenType} ${user.accessToken}`;
    const authReq = req.clone({ setHeaders: { Authorization: authToken } });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          window.localStorage.clear();
          this.router.navigateByUrl('/login');
        }

        if (error.status === 403) {
          this.forbiddenService.show();
        }

        throw error;
      })
    );
  }
}
